import { render, staticRenderFns } from "./SkipLinks.vue?vue&type=template&id=577be980&scoped=true"
import script from "./SkipLinks.vue?vue&type=script&lang=ts"
export * from "./SkipLinks.vue?vue&type=script&lang=ts"
import style0 from "./SkipLinks.vue?vue&type=style&index=0&id=577be980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577be980",
  null
  
)

export default component.exports